import { format as monthUtilFormat } from 'loot-core/src/shared/months';

import { useDateFormat } from '../../hooks/useDateFormat';
import { SvgCheck, SvgRemove } from '../../icons/v2';
import { type CSSProperties, theme } from '../../style';

enum AccountType {
  DEPOSITORY = 'DEPOSITORY',
  INVESTMENT = 'INVESTMENT',
  CREDIT = 'CREDIT',
  LOAN = 'LOAN',
  OTHER = 'OTHER',
}

type BankAccount = {
  account_id: string;
  institutionName: string;
  isOauth: boolean;
  lastSyncedAt: string;
  name: string;
  provider: string;
  status: 'OK' | 'ERROR';
  type: AccountType;
};

type IBankAccountDetailsProps = {
  account: BankAccount;
  style?: CSSProperties;
};

const dataContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  flex: 2,
};

const titleStyles = {
  fontSize: 14,
  lineHeight: 1,
  fontWeight: 600,
};

const rowStyles = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: 16,
  height: '100%',
};

const BankAccountDetails: React.FC<IBankAccountDetailsProps> = ({
  account,
  style,
}) => {
  const dateFormat = useDateFormat() || 'MM/dd/yyyy';

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: 24, ...style }}
    >
      <div style={rowStyles}>
        <div style={{ ...dataContainerStyles }}>
          <span style={titleStyles}>Institution name</span>
          <span>
            {account.institutionName ? account.institutionName : 'N/A'}
          </span>
        </div>
        <div style={{ ...dataContainerStyles, flex: 1 }}>
          <span style={titleStyles}>Provider</span>
          <span>{account.provider ? account.provider : 'N/A'}</span>
        </div>
        <div style={{ ...dataContainerStyles, flex: 1 }}>
          <span style={titleStyles}>Last sync date</span>
          <span>
            {account.lastSyncedAt
              ? monthUtilFormat(account.lastSyncedAt, dateFormat)
              : 'N/A'}
          </span>
        </div>
      </div>
      <div style={rowStyles}>
        <div style={dataContainerStyles}>
          <span style={titleStyles}>Institution account name</span>
          <span>{account.name ? account.name : 'N/A'}</span>
        </div>
        <div style={{ ...dataContainerStyles, flex: 1 }}>
          <span style={titleStyles}>Account type</span>
          {account.type ? (
            <span>
              {account.type.slice(0, 1)?.toUpperCase() +
                account.type.slice(1)?.toLowerCase()}
            </span>
          ) : (
            'N/A'
          )}
        </div>

        <div style={{ ...dataContainerStyles, flex: 1 }}>
          <span style={titleStyles}>OAuth</span>
          <span>
            {account.isOauth ? (
              <SvgCheck
                width={10}
                height={10}
                style={{ color: theme.gsGreen700 }}
              />
            ) : (
              <SvgRemove
                width={9}
                height={9}
                style={{ color: theme.errorBorder }}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
export default BankAccountDetails;
